import { FirebaseTokenInterface } from '../../..';

export class FirebaseTokenDto implements FirebaseTokenInterface {
  firebaseToken: string;
  userId: string;
}
